import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { Color } from 'csstype'
import React from 'react'
import { ListagemGestantePuerperaPreNatalPuerperioModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-gestantePuerpera'

export interface AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPreNatalSectionProps {
  gestantePuerpera: ListagemGestantePuerperaPreNatalPuerperioModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPreNatalSection({
  gestantePuerpera,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPreNatalSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='pregnant' color={iconColor} />
          <Text fontWeight='bold'>Pré-natal</Text>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Consultas</Text>
          <Text>{gestantePuerpera?.atendimentosPreNatalPuerperio?.consultasPreNatalGestacao ?? 0}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Consultas até 12 semanas</Text>
          <Text>{gestantePuerpera?.atendimentosPreNatalPuerperio?.consultasPrimeirasDozeSemanas ?? 0}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Consultas odontológicas</Text>
          <Text>{gestantePuerpera?.atendimentosPreNatalPuerperio?.consultasOdontologicasGestacao ?? 0}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
